import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, injectIntl, useIntl } from 'react-intl';

import intlShape from '@/shared/utils/intlShape';
import DataCacheService from '@/shared/services/DataCacheService';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import MultiSelect, { addItem, removeItem, splitItems } from './MultiSelect';

const messages = defineMessages({
  OwnCompanies: 'Own companies',
});

function CompanyMultiSelect({ selection, onChange, intl, placeholder = null }) {
  const dataCache = DataCacheService.getDataCache();
  if (!dataCache) return null;
  const companies = dataCache.company
    .map(x => ({ ...x, label: x.name }))
    .sort(dynamicSort('label'));
  const [selectedItems, selectableItems] = splitItems(companies, selection);

  return (
    <MultiSelect
      selectedItem={selectedItems}
      onItemRemoved={item => onChange(removeItem(selection, item))}
      onItemSelected={item => onChange(addItem(selection, item))}
      items={selectableItems}
      placeholder={placeholder || intl.formatMessage(messages.OwnCompanies)}
    />
  );
}

CompanyMultiSelect.propTypes = {
  selection: PropTypes.arrayOf(PropTypes.string).isRequired,
  onChange: PropTypes.func.isRequired, // (newSelection)=>{}
  placeholder: PropTypes.string,
  intl: intlShape.isRequired,
};

export default injectIntl(CompanyMultiSelect);
